module.exports = "/* Override global dialog styles for this specific component */\r\n::ng-deep .mat-dialog-container {\r\n  padding: 24px !important;\r\n  border-radius: 8px !important;\r\n}\r\n/* Ensure proper spacing for the form content */\r\n.create-admin-dialog {\r\n  padding: 0;\r\n  margin: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-dashboard/manage-users/create-admin-dialog/create-admin-dialog.component.css
// module id = ./src/app/admin-dashboard/manage-users/create-admin-dialog/create-admin-dialog.component.css
// module chunks = main